import { createTheme } from '@mui/material/styles';

// Create a custom theme for the Green Pioneers Webportal with enhanced modern colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#125283', // Green Pioneers blue - slightly brightened
      light: '#3778ad',
      dark: '#0b3659',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF7A00', // Green Pioneers vibrant orange
      light: '#ff9d3f',
      dark: '#c65e00',
      contrastText: '#ffffff',
    },
    success: {
      main: '#0CAA6E', // Brighter green for better visibility
      light: '#34D399',
      dark: '#059669',
      contrastText: '#fff',
    },
    error: {
      main: '#E53E3E', // Modern red
      light: '#F87171',
      dark: '#C53030',
      contrastText: '#fff',
    },
    info: {
      main: '#38BDF8', // Brighter blue for information
      light: '#7DD3FC',
      dark: '#0284C7',
    },
    warning: {
      main: '#F59E0B', // Modern amber for warnings
      light: '#FBBF24',
      dark: '#D97706',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#64748B',
    },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 22px',
        },
        containedPrimary: {
          boxShadow: '0px 4px 14px rgba(18, 82, 131, 0.25)',
          '&:hover': {
            boxShadow: '0px 6px 18px rgba(18, 82, 131, 0.35)',
          },
        },
        containedSecondary: {
          boxShadow: '0px 4px 14px rgba(255, 122, 0, 0.25)',
          '&:hover': {
            boxShadow: '0px 6px 18px rgba(255, 122, 0, 0.35)',
          },
        },
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          }
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          overflow: 'hidden',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
        },
        elevation2: {
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
        },
        elevation3: {
          boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.1)',
        },
        elevation4: {
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px',
          '&:last-child': {
            paddingBottom: '24px',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.875rem',
        },
      },
    },
  },
});

export default theme; 